import React from "react";
import Navbar from "../Navbar/Navbar";

export const Header = () => {
    return (
        <Navbar />
    );
}